import { useEffect, useState } from "react";
import { api } from "./utils";
import { getTenant } from "./helpers";

const useExperience = (username) => {
    const [experience, setExperience] = useState([]);
    const [experienceDataLoaded, setExperienceDataLoaded] = useState(false);

   useEffect(() => {
     api.ibldmcareer.getExperience(
       { org: getTenant(), username: username },
       (data) => {
         setExperience(Array.isArray(data) ? data : []);
         setExperienceDataLoaded(true);
       },
       (error) => {
        setExperienceDataLoaded(true);
          setExperience([]);
       }
     );

  
     
   }, [username]);

    return { experience, experienceDataLoaded, setExperience, setExperienceDataLoaded};
};

export default useExperience;